import 'array.prototype.tosorted/auto'
export default defineNuxtPlugin(()=>{})